


























































import {
  Component,
  Vue,
  Prop,
  Watch,
  Ref,
  PropSync,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { PointGroup } from 'signature_pad';

@Component({
  computed: {
    ...mapState('Auth', {
      user: 'user',
      userSignature: 'userSignature',
    }),
  },
})
export default class QUserSignature extends Vue {
  @PropSync('signature') signatureSync!: undefined | string;
  @Prop() signaturePadRawData!: string;
  @Prop({ default: '' }) padClass!: string;
  @Prop({ default: true }) showButton!: boolean;
  @Ref() readonly signaturePad!: {
    undoSignature: (any?: any) => void;
    saveSignature: (any?: any) => { isEmpty: boolean; data: undefined };
    fromDataURL: (
      dataUrl: string | undefined,
      options?: { ratio?: number; width?: number; height?: number },
      callback?: (error?: ErrorEvent) => void
    ) => void;
    clearSignature: (any?: any) => void;
    toData: (any?: any) => PointGroup[];
    fromData: (data: PointGroup[]) => void;
  };

  user!: Model;
  userSignature!: { signature_pad_raw_data: string };
  isLoading = false;
  image!: PointGroup[];
  imageString!: string;

  mounted() {
    this.$store.dispatch('Auth/getSignature').then(() => {
      this.signaturePad.clearSignature();
      if (!_.isEmpty(this.signatureSync)) {
        this.signaturePad.fromDataURL(this.signatureSync);
      } else if (!_.isEmpty(this.signaturePadRawData)) {
        this.signaturePad.fromData(JSON.parse(this.signaturePadRawData));
      } else if (!_.isEmpty(this.userSignature)) {
        this.signaturePad.fromData(
          JSON.parse(this.userSignature.signature_pad_raw_data)
        );
      }
    });
  }

  @Watch('userSignature', { deep: true })
  watchUserSignature(v) {
    if (v) {
      this.signaturePad.clearSignature();
      this.signaturePad.fromData(
        JSON.parse(this.userSignature.signature_pad_raw_data)
      );
    }
  }

  @Watch('signature')
  watchSignature(v) {
    if (v) {
      this.signaturePad.clearSignature();
      this.signaturePad.fromDataURL(this.signatureSync);
    }
  }

  @Watch('signaturePadRawData', { deep: true })
  watchSignaturePadRawData(v) {
    if (v) {
      this.signaturePad.clearSignature();
      this.signaturePad.fromData(JSON.parse(this.signaturePadRawData));
    }
  }

  undoSignature() {
    this.signaturePad.undoSignature();
  }

  saveSignature() {
    this.isLoading = true;
    const { isEmpty, data } = this.signaturePad.saveSignature();
    const payload = {
      signature_image: data,
      signature_pad_raw_data: JSON.stringify(this.signaturePad.toData()),
    };
    this.$store.dispatch('Auth/signature', payload).then(() => {
      this.isLoading = false;
      this.$store.commit('SET_SNACKBAR', {
        show: true,
        type: 'success',
        message: this.$i18n.t('common_word.success_update'),
      });
    });

    return { isEmpty: isEmpty, data: data };
  }

  clearSignature() {
    this.signaturePad.clearSignature();
  }

  getSignature() {
    const { isEmpty, data } = this.signaturePad.saveSignature();
    return {
      is_empty: isEmpty,
      signature_image: data,
      signature_pad_raw_data: JSON.stringify(this.signaturePad.toData()),
    };
  }

  resetSignature() {
    this.signaturePad.clearSignature();
    this.signaturePad.fromData(
      JSON.parse(this.userSignature.signature_pad_raw_data)
    );
  }

  setSignaturePadRawData(signaturePadRawData) {
    this.signaturePad.clearSignature();
    this.signaturePad.fromData(JSON.parse(signaturePadRawData));
  }
}
